import script from "./CreateButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateButton.vue?vue&type=script&lang=ts&setup=true"

import "./CreateButton.vue?vue&type=style&index=0&id=301c402c&lang=css&scoped=true"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301c402c"]])

export default __exports__